

(function ($) {
    $(function () {

        $('.js-show-details').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.js-details').slideToggle();
        })

        $('.js-toggle-summary').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $('.js-summary-content').slideToggle();
        })


        if ($('[id^=mpgft-signup-gift-checkbox').length) {
            var giftCheckbox = $('[id^=mpgft-signup-gift-checkbox');
            giftCheckbox.addClass('form-check-input');
            giftCheckbox.parent().addClass('form-check-label');
            giftCheckbox.parent().parent().addClass('form-check');
        }

        $('.mepr-form-radio').addClass('form-check-input');

        $('.js-go-to-step-2').click(function (e) {
            e.preventDefault();

            var hasError = false;
            var errorMessages = [];

            $('.js-step-1 .mepr-field-required').each(function (e) {

                var currentInput = $(this).find('.mepr-form-input:visible');
                var currentType = currentInput.attr('name');

                if (currentType == "mepr-address-country") {
                    currentInput = $(this).find('select');
                } else {
                    currentInput = $(this).find('.mepr-form-input:visible');
                }


                var currentValue = currentInput.val();

                if (currentValue == "") {
                    $(this).addClass('has--error js-has-error');

                    if (currentType == "mepr-address-one") {
                        errorMessages.push('Address Line 1 is required.');
                    }
                    if (currentType == "mepr-address-city") {
                        errorMessages.push('City is required.');
                    }

                    if (currentType == "mepr-address-country") {
                        errorMessages.push('Country is required.');
                    }

                    if (currentType == "mepr-address-state") {
                        errorMessages.push('State/Province is required.');
                    }

                    if (currentType == "mepr-address-zip") {
                        errorMessages.push('Zip/Postal Code is required.');
                    }

                    hasError = true;
                }
            });

            if (hasError) {
                $('.js-error-messages').html(errorMessages.map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                    Fancybox.show([{
                        src: "#general__error_modal",
                        type: "inline",
                        closeButton: false,
                        hideScrollbar: true
                    }]);
                });
                return false;
            }


            $('.js-step-1').hide();

            if ($('body.logged-in').length) {
                $('.js-step-3').show();
                $('.js-status-wrapper').addClass('active--3');
            } else {
                $('.js-step-2').show();
                $('.js-status-wrapper').addClass('active--2');
            }

            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        })

        $('.js-go-to-step-3').click(function (e) {
            e.preventDefault();


            var hasError = false;
            var errorMessages = [];

            if (!$.validateEmail($('#user_email1').val())) {
                errorMessages.push('Email must be a real and properly formatted email address.');
                hasError = true;
                $('#user_email1').parents('.mp-form-row').addClass('has--error js-has-error');
            }

            if (hasError) {
                $('.js-error-messages').html(errorMessages.map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                    Fancybox.show([{
                        src: "#general__error_modal",
                        type: "inline",
                        closeButton: false,
                        hideScrollbar: true
                    }]);
                });
                return false;
            }

            var email = $('#user_email1').val()
            if (email) {
                $.ajax({
                    url: localize.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'check_email_exists',
                        email: email,
                    },
                    success: function (response) {

                        if (response['fault']) {
                            errorMessages.push(response['msg']);
                            hasError = true;
                            $('#user_email1').parents('.mp-form-row').addClass('has--error js-has-error');
                        }


                        $('.js-step-2 .mepr-field-required').each(function (e) {

                            var currentInput = $(this).find('.mepr-form-input:not(.mepr-hidden)');
                            var currentType = currentInput.attr('name');


                            currentInput = $(this).find('input');

                            var currentValue = currentInput.val();

                            if (currentValue == "") {
                                $(this).addClass('has--error js-has-error');


                                if (currentType == "mepr_user_password") {
                                    errorMessages.push('You must enter a Password.');
                                }

                                if (currentType == "mepr_user_password_confirm") {
                                    errorMessages.push('You must enter a Password Confirmation.');
                                }

                                hasError = true;
                            }
                        });


                        if ($('.mepr-password-confirm').val() != $('.mepr-password').val()) {
                            errorMessages.push("Your Password and Password Confirmation don't match.");
                            hasError = true;
                            $('.mepr-password-confirm').parents('.mp-form-row').addClass('has--error js-has-error');
                            $('.mepr-password').parents('.mp-form-row').addClass('has--error js-has-error');
                        }


                        if (hasError) {
                            $('.js-error-messages').html(errorMessages.map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                                Fancybox.show([{
                                    src: "#general__error_modal",
                                    type: "inline",
                                    closeButton: false,
                                    hideScrollbar: true
                                }]);
                            });
                            return false;
                        }

                        $('.js-step-2').hide();
                        $('.js-step-3').show();
                        $('.js-status-wrapper').addClass('active--3');
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });

                    },
                    error: function (errorThrown) {
                        console.log(errorThrown);
                    },
                });
            }

        })


        $('.js-back-to-step-1').click(function (e) {
            e.preventDefault();
            $('.js-step-2').hide();
            $('.js-step-1').show();
            $('.js-status-wrapper').removeClass('active--2');
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        })


        $('.js-back-to-step-2').click(function (e) {
            e.preventDefault();

            if ($('body.logged-in').length) {
                $('.js-step-3').hide();
                $('.js-step-1').show();
                $('.js-status-wrapper').removeClass('active--3');
            } else {
                $('.js-step-3').hide();
                $('.js-step-2').show();
                $('.js-status-wrapper').removeClass('active--3');
            }

            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        })


        $('.js-try-submit').click(function (e) {
            e.preventDefault();
            var hasError = false;
            var errorMessages = [];
            if (!$('[id^=mepr_agree_to_tos')[0].checked) {
                $('.mepr_tos').addClass("has--error js-has-error");
                errorMessages.push("You must agree to the Terms of Service");
                hasError = true;
            }

            if (hasError) {
                $('.js-error-messages').html(errorMessages.map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                    Fancybox.show([{
                        src: "#general__error_modal",
                        type: "inline",
                        closeButton: false,
                        hideScrollbar: true
                    }]);
                });
                return false;
            }

            $('.js-mepr-submit').trigger('click');
        });


        if ($('.template--advanced-registration').length) {
            var errorObserver = new MutationObserver(checkErrors);
            var target = document.querySelector('.mepr-stripe-checkout-errors');

            if (target) {
                errorObserver.observe(target, {
                    childList: true,
                    subtree: true,
                    attributes: false,
                    characterData: false
                });
            }

            function checkErrors(e) {
                var errors = [];
                $('.mepr-stripe-checkout-errors').children().each(function (e) {
                    var errorMessage = $(this).html();
                    errors.push(errorMessage);

                    if (errorMessage.includes("Terms of Service")) {
                        $('.mepr_tos').addClass("has--error js-has-error");
                    }

                    if (errorMessage.includes("email address has already been used.")) {
                        $('#user_email1').parents('.mp-form-row').addClass('has--error js-has-error');
                    }


                });


                $('.js-error-messages').html(errors.map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                    Fancybox.show([{
                        src: "#general__error_modal",
                        type: "inline",
                        closeButton: false,
                        hideScrollbar: true
                    }]);
                });
                return false;
            }
        }


    });
})(jQuery);
